import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { IState } from '../../../store';
import { backToOffer } from '../../../actions/requestDemand';
import { RequestDemandSuccess } from '../../../components/RequestDemand/components/RequestDemandSuccess';

export const mapDispatchToProps = (dispatch: Dispatch<IState>) => ({
  onReturn() {
    dispatch(backToOffer());
  },
});

export const RequestDemandSuccessContainer = connect(undefined, mapDispatchToProps)(RequestDemandSuccess);
